import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-ngb-modal-backdrop',
  template: ''
})
export class NgbModalBackdropComponent implements OnInit {
  @Input() backdropClass: string;
  @HostBinding('class') backdropClassValue;
  @HostBinding('style.z-index') '1050';
  ngOnInit() {
    const bdClass = this.backdropClass ? ' ' + this.backdropClass : '';
    this.backdropClassValue = 'modal-backdrop fade show' + bdClass;
  }
}
